import { types } from "../actions";

const initialState = {
  combinedCountryTagData: [],
  countryIds: [],
  sites: [],
  loading: false,
  error: null,
  siteTagList: {},
  isMultiSite: false,
  isSiteModified: false,
  tagIdList: [],
  selectedSiteId: null,
  siteStatsCache: {},
  siteStatsPending: {},
};

const sitesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_COMBINED_COUNTRY_TAGDATA: {
      return { ...state, combinedCountryTagData: action.payload };
    }
    case types.PUT_FETCH_COUNTRY_REQUEST: {
      return { ...state, countryIds: action.payload };
    }
    case types.SET_COMBINED_SITES_TAGDATA: {
      return { ...state, combinedSitesTagData: action.payload };
    }
    case types.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case types.DELETE_SITE_REQUEST:
    case types.DELETE_SITE_SUCCESS:
    case types.FETCH_SITES_SUCCESS:
      return {
        ...state,
        sites: action.payload,
      };
    case types.FETCH_COUNTRY_IDS_SUCCESS:
      return { ...state };
    case types.DELETE_SITE_FAILURE:
    case types.FETCH_SITES_FAILURE:
    case types.FETCH_COUNTRY_IDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.UPDATED_SITE_TAG_LIST: {
      return {
        ...state,
        siteTagList: action.payload,
        isMultiSite: action.payload?.sites?.length > 1,
      };
    }
    case types.ADD_NEW_AREA: {
      return {
        ...state,
        siteTagList: {
          ...state.siteTagList,
          areas: [...(state.siteTagList?.areas || []), action.payload],
        },
      };
    }
    case types.ADD_NEW_SUBAREA: {
      return {
        ...state,
        siteTagList: {
          ...state.siteTagList,
          subareas: [...(state.siteTagList?.subareas || []), action.payload],
        },
      };
    }
    case types.PROCESS_NESTED_SITE_TAG_LIST: {
      const newSiteTagList = action.payload;

      const updatedSiteTagList = {
        ...state.siteTagList,
        ...newSiteTagList,
        countries: newSiteTagList?.countries || state.siteTagList.countries,
      };
      return {
        ...state,
        siteTagList: updatedSiteTagList,
        isMultiSite: action.payload?.sites?.length > 1,
      };
    }
    case types.SETALLTAGLIST: {
      return {
        ...state,
        tagIdList: action.payload,
      };
    }
    case types.ADD_NEW_CITY: {
      return {
        ...state,
        siteTagList: {
          ...state.siteTagList,
          cities: [...(state.siteTagList?.cities || []), action.payload],
        },
      };
    }

    case types.ADD_NEW_STATE: {
      return {
        ...state,
        siteTagList: {
          ...state.siteTagList,
          states: [...(state.siteTagList?.states || []), action.payload],
        },
      };
    }

    case types.SITES_MODIFIED: {
      return {
        ...state,
        isSiteModified: action.payload,
      };
    }

    case types.UPDATE_BUILDINGS: {
      return {
        ...state,
        siteTagList: {
          ...state.siteTagList,
          sites: action.payload,
        },
      };
    }

    case types.UPDATE_CAMPUS_DETAILS: {
      return {
        ...state,
        siteTagList: action.payload,
      };
    }

    case types.SET_SELECTED_SITE_ID: {
      return { ...state, selectedSiteId: action.payload };
    }

    case types.UPDATE_SITE_TAG_LIST_ITEM: {
    const { kind, id, updates } = action.payload;
      return {
        ...state,
        siteTagList: {
          ...state.siteTagList,
          [kind]: state.siteTagList[kind]?.map((item) =>
            item.id === id ? { ...item, ...updates } : item
          ),
        },
      };
    }

    case types.SET_SITE_STATS_CACHE: {
      const { siteId, data } = action.payload;
      return { ...state, siteStatsCache: { ...state.siteStatsCache, [siteId]: data } };
    }

    case types.SET_SITE_STATS_PENDING: {
      const { siteId, pending } = action.payload;
      return { ...state, siteStatsPending: { ...state.siteStatsPending, [siteId]: pending } };
    }

    default:
      return state;
  }
};
export default sitesReducer;
